import React from 'react'
import Icon from './icon'
import './toggler.css'

/**
 * Toggler
 * <Toggler modes={[{ mode: 'list', 'icon': 'view_comfy' }, { mode: 'table', 'icon': 'list' }]} />
 */
class TogglerIcon extends React.Component {

  state = {
    mode: 0
  }

  toggle = () => {
    const { modes, onChange } = this.props
    const max = modes.length
    const mode = this.state.mode === max-1 ? 0 : this.state.mode + 1
    this.setState({ mode })
    if (onChange) onChange(mode)
  }

  render() {
    const { modes } = this.props
    const mode = modes[this.state.mode]
    const icon = mode.icon
    const className = mode.style
    return ( <Icon icon={icon} className={`toggler ${className}`} clickable action={this.toggle}/> )
  }
}

export { TogglerIcon } ;



// WEBPACK FOOTER //
// ./src/lib/components/toggler.js